import { render } from "./PhotoComponent.vue?vue&type=template&id=d085995e"
import script from "./PhotoComponent.vue?vue&type=script&lang=js"
export * from "./PhotoComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\VueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__